<app-user-detail-nav [userObservable]="userObservable"></app-user-detail-nav>
<main>
  <router-outlet></router-outlet>
</main>







// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/users/user-detail/user-detail.component.html